export const PROFILE_PATH = '/user/profile'
export const USER_ACCOUNTS_PATH = '/user/accounts'
export const CREATE_DEMO_ACCOUNT_PATH = '/user/accounts/demo'
export const REGISTER_PATH = '/user/register'
export const CHECK_AVAILABLE_USER_NAME = '/user/username-available'
export const EMAIL_VERIFY = '/user/email/verification'
export const EMAIL_VERIFICATION_RESEND = '/user/email/verification/resend'
export const RESTORE_PASSWORD_PATH = '/user/restore/password'

export const CONTACTUS_PATH = '/contact-us'

export const APP_VERSION_PATH = '/app-version'

export const AUTH_LOGIN_PATH = '/auth/login'
export const AUTH_REFRESH_PATH = '/auth/refresh'
export const AUTH_GOOGLE = '/auth/google'
export const AUTH_GOOGLE_V2 = '/auth/google/v2'
export const AUTH_APPLE_V2 = '/auth/apple/v2'
export const ADMIN_USER_SESSIONS_PATH = '/auth/admin/user-sessions'

export const TRADING_LOG_PATH = '/trading-log'
export const CASH_FLOWS_PATH = '/trading-log/cash-flows'
export const ADMIN_CASH_FLOWS_PATH = '/trading-log/admin/cash-flows'
export const TRADING_PLAN_PATH = '/trading-plan'
export const GET_IMPORT_HISTORY_PATH = '/trading-log/upload-history'
export const LOGS_PATH = '/logs'
export const USER_SETTINGS_ACTIVITY_HISTORY_PATH = '/user/settings-history/activity'
export const USER_SETTINGS_IMPORT_HISTORY_PATH = '/user/settings-history/imports'
export const ACCOUNT_CONNECTION_LOGS_PATH = '/account-connection-logs'
export const DEV_CRON_PATH = '/cron/dev'
export const UPLOAD_HISTORY_FILE_PATH = '/trading-log/upload-history-file'
export const GET_IMPORT_XLSX_TEMPLATE = '/trading-log/import/xlsx-template'
export const UPLOAD_HISTORY_XLSX_FILE_PATH = '/trading-log/import/upload-xlsx'

export const DAILY_STATS_PATH = '/daily-stats'

export const JOURNALING_GET_PATH = '/journaling/get'
export const JOURNALING_SAVE_PATH = '/journaling/save'
export const JOURNALING_MASS_FILL_SAVE_PATH = '/journaling/mass-fill'

export const UPDATE_USER_PROFILE = '/user/profile/update'
export const CHECK_USER_PASSWORD = '/user/check-password'
export const CHANGE_USER_PASSWORD = '/user/change-password'
export const DELETE_USER_ACCOUNT = '/user/delete-account'
export const GET_TRADING_INFO_QUESTIONS = '/user/profile/get-trading-info-questions'
export const SAVE_TRADING_INFO = '/user/profile/save-trading-info'
export const ALL_USERS_PATH = '/user/all' //Admin only
export const GET_ALL_USERS_CSV_PATH = '/user/all-csv'
export const GET_USERS_WITHOUT_ACCOUNT_CSV = '/user/without-account-csv'
export const GET_ACTIVE_USERS_CSV = '/user/active-users-csv'
export const GET_UNACTIVE_USERS_CSV = '/user/unactive-users-csv'
export const GET_PROP_FIRM_ACCOUNTS_CSV = '/user/prop-firm-accounts-csv'
export const BLOCKED_IPS_PATH = '/blocked-ip'

export const GET_QUESTIONNAIRE_QUESTIONS = '/user/profile/get-user-questionnaire-questions'
export const SAVE_QUESTIONNAIRE = '/user/profile/save-user-questionnaire-answers'

export const REPORTS_TIME_PATH = '/reports/time'
export const REPORTS_DURATION_PATH = '/reports/duration'
export const REPORTS_PSYCHOLOGY_PATH = '/reports/psychology'
export const REPORTS_RISK_PATH = '/reports/risk-management'
export const REPORTS_STRATEGY_PATH = '/reports/trading-strategy'
export const REPORTS_TRADING_CONFLUENCE_PATH = '/reports/trading-confluence'
export const REPORTS_INSTRUMENTS_PATH = '/reports/instruments'

export const BROKERS_PATH = '/brokers'
export const PLATFORMS_PATH = '/platforms'

export const METRICS_PATH = '/dashboard/metrics'
export const DASHBOARD_CALENDAR_PATH = '/dashboard/calendar'
export const OPEN_POSITION_TABLE_PATH = '/dashboard/positions/open'
export const CLOSE_POSITION_TABLE_PATH = '/dashboard/positions/closed'
export const COMMISSION_STATS_PATH = '/trading-log/commission-stats'
export const TRADED_SYMBOLS_PATH = '/trading-log/symbols'
export const COMMISSION_BENCHMARK_REFERENCE_PATH =
  '/trading-log/admin/commission-benchmark/reference'
export const COMMISSION_BENCHMARK_ACCOUNTS_PATH = '/trading-log/admin/commission-benchmark/accounts'
export const COMMISSION_BENCHMARK_ACCOUNTS_CSV_PATH =
  '/trading-log/admin/commission-benchmark/accounts-csv'
export const COMMISSION_BENCHMARK_ACCOUNT_BREAKDOWN_PATH =
  '/trading-log/admin/commission-benchmark/account-breakdown'
export const COMMISSION_BENCHMARK_RECALCULATE_ACCOUNT_SPREAD_PATH =
  '/trading-log/admin/commission-benchmark/recalculate-account-spread'
export const ADMIN_METRICS_PATH = '/dashboard/admin-metrics'
export const ADMIN_BREACH_EVENTS_PATH = '/dashboard/admin-breach-events'
export const ADMIN_METRICS_BY_COUNTRY_PATH = '/dashboard/admin-metrics-by-country'
export const ADMIN_METRICS_BY_COUNTRY_CHART_PATH = '/dashboard/admin-metrics-by-country/chart'
export const ADMIN_REGISTRATION_PLATFORM_METRICS_PATH =
  '/dashboard/admin-registration-platform-metrics'
export const ADMIN_BROKER_SERVERS_PATH = '/dashboard/admin-broker-servers'
export const GET_TRADING_LOG_STATS = '/dashboard/trading-log-stats'
export const GET_USER_QUESTIONNAIRE_STATS = '/dashboard/user-questionnaire-stats'
export const GET_PLATFORM_REQUEST_STATS = '/dashboard/platform-request-stats'
export const GET_TRACKED_LINK_CLICK_STATS = '/dashboard/tracked-link-click-stats'
export const GET_TRACKED_LINK_CLICK_COUNTRY_STATS = '/dashboard/tracked-link-click-stats/by-country'
export const ADMIN_ACTIVATION_FUNNEL_METRICS_PATH = '/activation-funnel/admin/metrics'
export const ADMIN_ACTIVATION_FUNNEL_BACKFILL_PATH = '/activation-funnel/admin/backfill'
export const ADMIN_ACTIVATION_FUNNEL_EVENTS_PATH = '/activation-funnel/admin/events'
export const ADMIN_ACTIVATION_FUNNEL_USERS_PATH = '/activation-funnel/admin/users'
export const ADMIN_FEATURE_USAGE_OVERVIEW_PATH = '/feature-usage/admin/overview'
export const ADMIN_FEATURE_USAGE_BACKFILL_PATH = '/feature-usage/admin/backfill'
export const ADMIN_FEATURE_USAGE_USERS_PATH = '/feature-usage/admin/users'
export const ADMIN_FEATURE_USAGE_ACTIVE_SESSIONS_PATH = '/feature-usage/admin/active-sessions'
export const ADMIN_FEATURE_USAGE_SESSIONS_PATH = '/feature-usage/admin/sessions'
export const ADMIN_FEATURE_USAGE_COHORTS_PATH = '/feature-usage/admin/cohorts'
export const ADMIN_FEATURE_USAGE_EVENTS_PATH = '/feature-usage/admin/events'
export const ADMIN_CHURN_SIGNALS_LIST_PATH = '/churn-signals/admin/list'
export const ADMIN_CHURN_SIGNALS_CSV_PATH = '/churn-signals/admin/csv'
export const ADMIN_CHURN_SIGNALS_RUN_PATH = '/churn-signals/admin/run'
export const ADMIN_CHURN_SIGNALS_STATUS_PATH = '/churn-signals/admin/:id/status'
export const ADMIN_TRADER_PROFITABILITY_OVERVIEW_PATH = '/trader-profitability/admin/overview'
export const ADMIN_TRADER_PROFITABILITY_LIST_PATH = '/trader-profitability/admin/list'
export const ADMIN_TRADER_PROFITABILITY_CSV_PATH = '/trader-profitability/admin/csv'
export const ADMIN_TRADER_PROFITABILITY_RECALCULATE_PATH = '/trader-profitability/admin/recalculate'
export const TRACK_AI_MARKET_INSIGHT_VIEWED_PATH = '/feature-usage/track/market-insight-viewed'
export const ADMIN_MAILCHIMP_PATH = '/mailchimp/admin'

export const FETCH_ALL_JOURNALING_COMPLETION_BY_IDS =
  '/trading-log/get-journaling-completion-by-ids'
export const SERVERS_LIST_PATH = '/brokers/servers'
export const LAST_ACCOUNT_UPDATE_PATH = '/user/accounts/last-upload'
export const REFRESH_ACCOUNT_DATA_PATH = '/user/accounts/auto-upload'
export const ADMIN_REFRESH_ACCOUNT_DATA_PATH = '/user/accounts/admin/auto-upload'
export const GENERATE_TRADE_IMAGE_PATH = '/sharing-feature/generate'
export const REPORTS_DRAWDOWN_PATH = '/reports/drawdown'
export const GET_AUTO_UPLOAD_STATUS_PATH = '/user/accounts/auto-upload-status'
export const GET_ALL_USER_ACCOUNTS_PATH = '/user/accounts/all'
export const GET_ALL_USER_ACCOUNTS_CSV_PATH = '/user/accounts/all-csv'
export const GET_CASH_FLOW_VERIFICATION_CSV_PATH = '/user/accounts/cash-flow-verification-csv'
export const GET_TOP_USER_ACCOUNTS_PATH = '/user/accounts/top'
export const SET_EXCLUDED_FROM_TOP_ACCOUNTS_PATH = '/user/accounts/set-excluded-from-top'
export const SET_ACCOUNT_CFD_STATUS_PATH = '/user/accounts/set-cfd-status'
export const BROKER_IDENTIFIERS_PATH = '/broker-identifiers'

export const GET_PROGRAM_PATH = '/education/programs/get'
export const CHANGE_LESSON_STATUS_LESSON_PATH = '/education/change-lesson'
export const GET_QUIZ_PATH = '/education/quiz/get'
export const SAVE_QUIZ_PATH = '/education/quiz/save'
export const GET_REWARDS_PATH = '/education/rewards/get'
export const GET_USER_REWARD_PATH = '/education/rewards/user/get'
export const GET_WEBINARS = '/webinars'

export const CREATE_PLATFORM_REQUEST = '/platform-requests'
export const CREATE_TRACKED_LINK_CLICK = '/tracked-link-clicks'

export const AI_MARKET_NEWS_PATH = '/news/by-symbols'
export const NEWS_SYMBOLS_WITH_NEWS_PATH = '/news/symbols-with-news'
export const NEWS_PERIOD_AI_ANALYSIS = '/news-summary/period-ai-analysis'
export const NEWS_LAST_PERIOD_AI_ANALYSIS = '/news-summary/last-period-ai-analysis'

export const TRADE_AI_ANALYSIS_PATH = '/trade-ai'
